// this are the core dependencies for the whole site
// we bring them into global scope to resolve for legacy javascript
global.jQuery = require("jquery");
global.$ = global.jQuery;

global.$ = global.jQuery = require("jqvalidate");
require("jquery-autotab");
global.qq = require("fine-uploader");


//////////////////
// WEBPACK FOOTER
// ./Scripts/site-master.js
// module id = 1
// module chunks = 0